// // import { Component } from '@angular/core';

// // import { MENU_ITEMS } from './pages-menu';

// // @Component({
// //   selector: 'ngx-pages',
// //   styleUrls: ['pages.component.scss'],
// //   template: `
// //     <ngx-one-column-layout>
// //       <nb-menu [items]="menu"></nb-menu>
// //       <router-outlet></router-outlet>
// //     </ngx-one-column-layout>
// //   `,
// // })
// // export class PagesComponent {
// // menu = [];
// //  ngOnInit(): void {
// //   setTimeout(()=> {
// //     this.menu = MENU_ITEMS;
// //   },1000)
// //  }
// // }

// import { Component, OnInit } from '@angular/core';
// import { MenuService } from './pages-menu'; // Import the service
// import { NbMenuItem } from '@nebular/theme'; // Import the type

// @Component({
//   selector: 'ngx-pages',
//   styleUrls: ['pages.component.scss'],
//   template: `
//     <ngx-one-column-layout>
//       <nb-menu [items]="menu"></nb-menu>
//       <router-outlet></router-outlet>
//     </ngx-one-column-layout>
//   `,
// })
// export class PagesComponent implements OnInit {
//   menu: NbMenuItem[] = []; // Define menu as an array of NbMenuItem

//   constructor(private menuService: MenuService) {} // Inject the MenuService

//   ngOnInit(): void {
//     // Fetch the menu items dynamically from the service
//     this.menuService.getMenuItems().subscribe((items: NbMenuItem[]) => {
//       this.menu = items;
//     });
//   }
// }

import { Component, OnInit } from '@angular/core';
import { MenuService } from './pages-menu';
import { NbMenuItem } from '@nebular/theme';

@Component({
  selector: 'ngx-pages',
  styleUrls: ['pages.component.scss'],
  template: `
    <ngx-one-column-layout>
      <nb-menu [items]="menu"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
  `,
})
export class PagesComponent implements OnInit {
  menu: NbMenuItem[] = [];

  constructor(private menuService: MenuService) { }

  ngOnInit(): void {
    // Subscribe to role changes
    this.menuService.getRole().subscribe(() => {
      this.updateMenu();
    });

    // Initial menu setup
    this.updateMenu();
  }

  private updateMenu(): void {
    this.menuService.getMenuItems().subscribe((items: NbMenuItem[]) => {
      this.menu = items;
    });
  }
}
